import React from 'react';
import { InvoiceRecord } from '@types';
import { AuditLog } from '@organisms';

interface FileInfoSectionProps {
  invoice: InvoiceRecord;
}

export const FileInfoSection: React.FC<FileInfoSectionProps> = ({ invoice }) => {
  return (
    <div className="pt-4">
      <h3 className="text-sm font-medium text-secondary-700 mb-3">File Information</h3>
      <div className="space-y-2 text-sm text-secondary-600">
        <div>
          <span className="font-medium">Original Filename:</span>
          <p className="text-secondary-500">{invoice.original_filename || 'N/A'}</p>
        </div>
        <div>
          <span className="font-medium">New Filename:</span>
          <p className="text-secondary-500">{invoice.pdf_filename || 'N/A'}</p>
        </div>
        <div>
          <span className="font-medium">Created:</span>
          <p className="text-secondary-500">
            {new Date(invoice.created_at)?.toLocaleString()}
          </p>
        </div>
        <div>
          <span className="font-medium">Last Updated:</span>
          <p className="text-secondary-500">
            {new Date(invoice.updated_at).toLocaleDateString('en-AU')}
          </p>
        </div>
      </div>
      
      {/* Separator Line */}
      <div className="border-t border-secondary-200 mt-4"></div>
      
      {/* Audit Log */}
      <AuditLog 
        entityId={invoice.id} 
        entityType="invoice" 
        className="pt-4" 
      />
    </div>
  );
};
